// extracted by mini-css-extract-plugin
export default {"root":"VZMbm89fzHuumKKSNdPb","addToCart":"z8QiDixMPSOOi87wSJ1D","placeholderAnimate":"l2MpGwKV7ZGTTrUh9f9g"};